<template>
    <section class="background-image pb-20 overflow-hidden">
        <div class=" mt-40 ">
            <div class=" w-1/2 m-auto md:w-full">
                <div>
                    <img class=" w-1/2 m-auto" src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo">
                    <p class="font-nunitosans text-2xl text-gray-400 text-center">ADMIN</p>
                </div>

                <div class=" w-4/5 m-auto  font-poppins mt-8">
                   
                    <form @submit.prevent="adminLogin">
                        <div>
                            <input v-model="adminId" class="border w-full h-14 pl-6 border-gray-400 rounded-2xl" type="text" name="admin-id" id="admin-id" placeholder="Admin ID" >
                            <p v-if="adminIdValidity === 'incorrect' " class="text-xs text-red-500">please enter your id</p>
                        </div>

                        <div class=" mt-8">
                            <div class="flex">
                                <input v-model="adminPassword" :type="[showPassword ? 'text' : 'password']" class="border w-full border-gray-400 h-14 pl-6 rounded-2xl" name="password" id="password" placeholder="Admin Password" >
                                <div>
                                    <span @click="showPassword = !showPassword">
                                        <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                                    </span>
                                </div>
                            </div>
                            <p v-if="adminPasswordValidity === 'invalid' " class="text-xs text-red-500">please enter your password</p>
                            <p v-if="detailsValidity === 'incorrect' " class="text-xs text-red-500">Incorrect Password or Email</p>
                            <div class="mt-2 text-sm text-blue-600">
                                <router-link to="/forgot-password">Forgot Password?</router-link>
                            </div>
                        </div>
                        <div>
                            <p class="text-red-500 text-sm">{{detailsValidity}}</p>
                        </div>

                        <div class=" flex justify-center mt-10">
                            <button type="submit" style="backgroundColor:#08B3F4" class=" w-1/3 p-3 text-white rounded-2xl">Login</button>
                            <p v-if="isLoading" class="ml-2 mt-2 fa fa-spinner fa-spin fa-2x text-blue-700 "></p>
                        </div>
                         
                    </form>
                </div>
            </div>
        </div>
        
        
        
    </section>
</template>

<script>
import axios from 'axios';
import {baseUrl} from '../../Config';
const url = baseUrl;
export default {
    components: {
    },
    data() {
        return {
            adminId: '',
            adminPassword: '',
            isLoading: false,
            incorrect: false,
            status: "",

            adminIdValidity : '',
            adminPasswordValidity: '',
            validity: '',
            showPassword:false,
            detailsValidity:"",
            ipAddress: ""
        }
    },

    mounted() {
        this.networkError();
        this.getIpAddress();
    },

    methods: {
        adminLogin(){    
            if (!this.adminId) {
                this.adminIdValidity = 'invalid'
                setTimeout(() => {
                    this.adminIdValidity = ""
                }, 3000);
            }else if (!this.adminPassword) {
                this.adminPasswordValidity = 'invalid'
                setTimeout(() => {
                    this.adminPasswordValidity = ""
                }, 3000);
            } 
            
            else {
                this.validity = 'valid'; 
                this.isLoading = true;
                axios({
                    method: 'post',
                    url: `${url}/v1/web/auth/login/`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        email: this.adminId,
                        password : this.adminPassword,
                        ipAddress : this.ipAddress
                    }
                    })
                    .then((response) => {
                        localStorage.setItem('user', JSON.stringify(response.data.data.user))
                        localStorage.setItem('userEmail', response.data.data.user.email)
                        localStorage.setItem('userType', response.data.data.user.userType)
                        localStorage.setItem('token', response.data.data.tokens.access.token)
                        localStorage.setItem('refereshToken', response.data.data.tokens.refresh.token)
                        localStorage.setItem('userId', response.data.data.user.id)
                        this.$store.dispatch('setToken', response.data.data.tokens.access.token)
                        this.$store.dispatch('userDetails', response.data.data.user)
                        this.$store.dispatch('userId', response.data.data.userId)
                        this.$router.push('/admin/dashboard')
                    })
                    .catch((error) => {
                        this.detailsValidity = error.response.data.message
                        setTimeout(() => {
                            this.detailsValidity = ""
                        }, 3000);
                        this.isLoading = false;
                    })
            }
        },

        getIpAddress() {
            axios({
            method: 'GET',
            url: `https://ipapi.co/json/`,
            headers: {
                'Content-type': 'application/json',
            }
            })
            .then((res) => {
                this.ipAddress = res.data.ip;
                localStorage.setItem("ipAddress", this.ipAddress)
            })
            .catch(err => err)
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>

<style scoped>
.background-image {
    background-image:linear-gradient(rgba(255, 255, 255, 0.6), rgba(255,255,255,0.5)), url('../LandingPages/Images/image 27.png');
    background-repeat: no-repeat;    
    background-size: cover;
}
</style>